import * as React from "react";
import * as ReactDOM from "react-dom";
import Slider, { createSliderWithTooltip } from "rc-slider";
import { useFormikContext, Field, Form, Formik, FormikProps, FormikTouched } from 'formik';
import { ThousandSeperator } from './applicationform'
const SliderWithTooltip = createSliderWithTooltip(Slider);
import { APIApi } from "../lib-api";
import { ApiConfiguration } from "../src/apiConfiguration";
const interest = 0.064 / 12;

const StepOne: React.FunctionComponent = () => {
    const { values, setFieldValue, errors, touched, handleChange, isSubmitting, handleBlur } = useFormikContext<any>();
    const api = new APIApi(ApiConfiguration)


    function changeAmount(amount: number) {
        setFieldValue("amount", amount)
        setFieldValue("inputamount", amount)
        if (values.oldLoan > values.amount || !values.oldLoanExist)
            setFieldValue("oldLoan", amount)
    }

    function channgeRepaymentTime(increase: boolean) {


        var field = (document.getElementById("repaymentTime") as HTMLInputElement);

        if (increase && values.repaymentTime != 20) {
            setFieldValue("repaymentTime", values.repaymentTime + 1);
            field.value = (parseInt(field.value) + 1).toString()

        }
        else if (!increase && values.repaymentTime != 1) {
            setFieldValue("repaymentTime", values.repaymentTime - 1);
            field.value = (parseInt(field.value) - 1).toString()

        }
    }

    function postApp() {
        console.log(errors.email)
        console.log(errors.phoneNumber)
        if (errors.email == undefined && errors.phoneNumber == undefined) {

            const id = api.createApplication({
                email: values.email,
                loanAmount: values.amount,
                originReference: values.originReference,
                phone: values.phoneNumber,
                repaymentPeriod: values.repaymentTime,
                acceptMail: values.acceptMail
            })
            id.then(val => {
                window.location.href = val;
            })

        }


    }

    function ChangeBlur() {
        setFieldValue("amount", values.inputamount)
        if (values.oldLoan > values.inputamount || !values.oldLoanExist)
            setFieldValue("oldLoan", values.inputamount)
    }

    return (
        <div>
            <div className="slider-header row">
                <div className="col-6 col-lg-7 slider-text">Vålj lånebelopp:</div>
                <div className="input-shadow-container col-6 col-lg-5">
                    <input className="amount-input" onChange={handleChange} onBlur={ChangeBlur} name="inputamount" value={values.inputamount} defaultValue={values.amount} min="5000" max="600000"></input>
                    <div className="input-value">kr</div>
                </div>
            </div>
            <SliderWithTooltip
                name={"amount"}
                tipProps={{ defaultVisible: false, visible: false }}
                step={5000}
                min={5000}
                max={600000}
                onChange={(e) => changeAmount(e)}
                defaultValue={values.amount}
                value={values.amount}
            />
            <div className="d-flex justify-content-between slider-value">
                <div className="label">5000 kr</div>
                <div className="label">600 000 kr</div>
            </div>
            <hr />
            <div className="slider-header row">
                <div className="col-5 slider-text">Vålj lånetid:</div>
                <div className="input-shadow-container col-7">
                    <div className="time-button minus" onClick={() => channgeRepaymentTime(false)}>-</div>
                    <input className="repayment-time-input" type="number" min="1" max="20" name="repaymentTime" id="repaymentTime" onChange={handleChange} defaultValue={values.repaymentTime} />
                    <div className="input-value">år</div>
                    <div className="time-button plus" onClick={() => channgeRepaymentTime(true)}>+</div>
                </div>

            </div>
            <div className="monthlyCost">
                <div className="label">Cirka månadskostnad</div>
                <div>{ThousandSeperator(Math.round(values.amount * interest / (1 - Math.pow(1 + interest, -(values.repaymentTime * 12)))))} kr/mån</div>
            </div>
            <div className="oldloan-switch">
                <div style={{ margin: "auto 10px auto 0" }}>Vil du samla lån?</div>
                <label className="switch">
                    <input type="checkbox" name="oldLoanExist" id="oldLoanExist" defaultChecked={values.oldLoanExist} onChange={handleChange} />
                    <span className="dot"></span>
                </label>

            </div>

            {values.oldLoanExist &&
                <div className="old-loan-container">
                <strong>Hur mycket av {ThousandSeperator(values.amount)} kr vill du samla?</strong>
                <div className="input-shadow-container" style={{ justifyContent:"center" }}>
                        <input onChange={handleChange} name="oldLoan" defaultValue={values.oldLoan} min="5000" max={values.amount}></input>
                        <div className="input-value">kr</div>
                    </div>
                </div>}
            <div className="form-group" style={{ marginBottom: "0px" }}>
                <div className="d-flex">
                    {!errors.email && touched.email ? <span className="input-valid"><img src="/images/shield-color.svg" /></span> : <span className="input-valid"><img src="/images/shield.svg" /></span>}
                    <div className="input-icon"><img src="/images/mail.svg" /></div><Field type="email" name="email" id="email" className={errors.email && touched.email ? "text-input email-input error" : "text-input email-input"} onChange={handleChange} placeholder=" " />
                    <label htmlFor="email" className="form-control-placeholder control-label">E-postadress</label>
                </div>
                <div className="error-container">
                    {errors.email && touched.email && (<div className="text-danger">{errors.email}</div>)}</div>
            </div>
            <div className="form-group" style={{ marginTop: "0px" }}>
                <div className="d-flex">
                    {!errors.phoneNumber && touched.phoneNumber ? <span className="input-valid"><img src="/images/shield-color.svg" /></span> : <span className="input-valid"><img src="/images/shield.svg" /></span>}
                    <div className="input-icon"><img src="/images/phone.svg" /></div><Field name="phoneNumber" type="tel" id="phoneNumber" className={errors.phoneNumber && touched.phoneNumber ? "text-input email-input error" : "text-input email-input"} onChange={handleChange} placeholder="07 _ _  _ _  _ _  _ _" />
                </div>
                <div className="error-container">
                    {errors.phoneNumber && touched.phoneNumber && (<div className="text-danger">{errors.phoneNumber}</div>)}</div>
            </div>
            <div className="loan-agreement">
                <label>Skicka ansökan för att godkänna <a href="/dataskyddspolicy">dataskyddspolicyn</a> och <a href="/användarvillkor">användaravtalet</a></label>
            </div>
            <div className="col-12">
                    <div>
                        <label className="sign-check">
                            <input value={values.acceptMail} name="acceptMail" id="acceptMail" type="checkbox" onChange={handleChange} defaultChecked={values.acceptMail} />
                            <span className="checkmark"></span>
                        </label>

                        <label className="sign-label">
                        Jag vill få erbjudanden och nyheter från Lendsafe.se, via E-post och sms.
                        </label>
                    </div>
            </div>
            <button type="button" onClick={postApp} disabled={isSubmitting} className={(!errors.email && touched.email && !errors.phoneNumber && touched.phoneNumber) ? "submit btn-green shine" : "submit btn-green"} id="btn-next">Påbörja ansökan</button>
            <div className="example">Exempel: Räntan är rörlig och sätts individuellt. Annuitetslån <span>{ThousandSeperator(values.amount)} kr</span>, <span>{values.repaymentTime} år</span>, nom. ränta 6,4%, start-/aviag. 0 kr ger eff. ränta 6,59 %. Totalkostnad: <span>{ThousandSeperator(Number(((values.amount * interest / (1 - Math.pow(1 + interest, -(values.repaymentTime * 12)))) * values.repaymentTime * 12).toFixed(0)))} kr</span> eller  <span>{ThousandSeperator(Number((values.amount * interest / (1 - Math.pow(1 + interest, -(values.repaymentTime * 12)))).toFixed(0)))} kr/månad</span>. Återbet. tid <span>{values.repaymentTime} år.</span> Eff. ränta, 3,01%-29,95%</div>

        </div>
    )
}

export default StepOne;